import { Component, OnInit } from '@angular/core';
import { MenuController, LoadingController, ModalController, NavController } from '@ionic/angular';
import { GlobalsService } from '../../shared/globals';
import { CommonService } from '../../shared/common';
import { messages, Constants } from 'src/app/shared/constants';
import { LoginService } from '../../services/login.service';
import { Md5 } from "md5-typescript";
import { Storage } from '@ionic/storage';
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  public userId = '';//rajesh.gv1186@gmail.com'bbourdage@techpro.com';//'admin';
  public password = '';//'Password2';//"Password2";
  versionNo;
  isDev=false;
  constructor(
    private menuCtrl: MenuController,
    private navigationCtrl: NavController,
    private globals: GlobalsService,
    private commonService: CommonService,
    private loginService: LoginService,
    private storage: Storage
    
  ) {
    this.menuCtrl.enable(false);
  }

  ngOnInit() {
    this.versionNo = Constants.VersionNo;
    if(Constants.IsDEV==1){
      this.isDev = true;
    }
  }
  async loginClick() {


    let validationMessage = ""
    if (this.userId === null || this.userId === undefined || this.userId.trim() == "") {
      validationMessage = messages.ENTERUSERNAME;
    } else if (this.password === null || this.password === undefined || this.password.trim() == "") {
      validationMessage = messages.ENTERPASSWORD;
    }
    if (validationMessage != "") {
      this.commonService.showAlert(messages.ALERTTITLINFORMATION, validationMessage, ['OK']);
      return;
    }
    if (navigator.onLine) {
      const loader = await this.commonService.showLoading(messages.VALIDATINGUSER);
      var md5Passowrd = Md5.init(this.password);
      this.globals.userInfo.userName = this.userId;
      this.globals.userInfo.password = md5Passowrd;
      this.loginService
        .authenticateUser(this.userId, md5Passowrd)
        .then((data: any) => {
        
          if (data.UserID > 0) {
            if(!data.HasAccessToPortal) {
              loader.dismiss();
              this.commonService.showAlert(messages.ALERTTITLINFORMATION,  messages.ACCESSRESTRICTED , ['OK']);
              return;
            }
            loader.dismiss();
            this.menuCtrl.enable(true);
            this.storage.set('firstName', data.FirstName);
            this.storage.set('lastName', data.LastName);
            this.storage.set('username', this.userId);
            this.storage.set('password', md5Passowrd);
            this.storage.set('accessToken', data.ParticleClientSecret);
            this.storage.set('LoggedInUserID', data.UserID);
            this.globals.userInfo.LoggedInUserID = data.UserID;
            this.globals.userInfo.userName = this.userId;
            this.globals.userInfo.password = md5Passowrd;
            this.globals.userInfo.lastName = data.LastName;
            this.globals.userInfo.firstName = data.FirstName;
            this.globals.userInfo.accessToken = data.ParticleClientSecret;
            this.navigationCtrl.navigateRoot('/dashboard', { queryParams: { Title: 'Dashboard' } });
          } else{
            loader.dismiss();
            this.commonService.showAlert(messages.INVALIDCREDENTIALS, validationMessage, ['OK']);
          }
        })
        .catch((e) => {
          loader.dismiss();
        });
    } else{
      this.commonService.showAlert(messages.ALERTTITLINFORMATION,  messages.PLEASECONNECTTONETWORK , ['OK']);
    }

  }

}
